export default "/_next/static/b45cced3026afcf42e209f9a6321825b.png";